const createIdByDay = (date) => {
    return date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()
}

const createIdByMonth = (date) => {
    return (date.getMonth() + 1) + "-" + date.getFullYear()
}

export default {
    createIdByDay,
    createIdByMonth
}